export const FIELD_LIMITS = {
  name: 150,
  serviceType: 80,
  phone: 30,
  email: 254,
  website: 500,
  blurb: 250,
  moderatorNote: 500,
  message: 2000,
  eventTitle: 120,
  eventDescription: 5000,
} as const;

export const SERVICE_TYPES = [
  'Accounting',
  'Building & Renovation',
  'Catering',
  'Childcare',
  'Cleaning',
  'Electrical',
  'Gardening & Landscaping',
  'Hair & Beauty',
  'Handyman',
  'Legal',
  'Music Lessons',
  'Photography',
  'Plumbing',
  'Tutoring',
  'Other',
] as const;

export const MIN_FORM_SUBMIT_MS = 3000;

export const RATE_LIMITS = {
  perHour: 3,
  perDay: 10,
} as const;

export const LISTINGS_JSON_PATH = '/community-directory/listings.json';

export const EVENTS_JSON_PATH = '/events/events.json';

export const VIC_DATES_JSON_PATH = '/events/vic-dates.json';

/** Stored on draft events when no date is set yet (DynamoDB GSI sort key). */
export const PLACEHOLDER_EVENT_DATE = '9999-12-31';

export const SCHOOL_TERM_MIN = 1;
export const SCHOOL_TERM_MAX = 4;
export const SCHOOL_YEAR_MIN = 2020;
export const SCHOOL_YEAR_MAX = 2035;

export const IMAGE_MAX_BYTES = 5 * 1024 * 1024;

export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;

export const EXPIRY_MONTHS = [3, 6, 12] as const;

export type ExpiryMonths = (typeof EXPIRY_MONTHS)[number];
